import { render, staticRenderFns } from "./symposium_home.vue?vue&type=template&id=30982a1a&scoped=true&"
import script from "./symposium_home.vue?vue&type=script&lang=js&"
export * from "./symposium_home.vue?vue&type=script&lang=js&"
import style0 from "./symposium_home.vue?vue&type=style&index=0&id=30982a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30982a1a",
  null
  
)

export default component.exports